export default "__VITE_ASSET__CRulgvMw__"